module.exports = __webpack_public_path__ + "static/media/book-your-flu-shot-news.e1812d58.jpg";